import React from "react";
import { ToggleContextType } from "../Interfaces/ToggleContextTypes";

const toggleContext = React.createContext<ToggleContextType | null>(null);

export default toggleContext;